import { Route } from '@angular/router';
import { authGuard } from '@routes/guards/auth.guard';
import { guard } from '@routes/guards/guard-factory';

export const regionsRoutes: Route[] = [
    {
        path: 'regions',
        title: 'PRSS | Регионы',
        loadComponent: () =>
            import('@pages/guids/regions/regions.component').then((c) => c.RegionsComponent),
        canActivate: [authGuard, guard('watch_refs_regions')],
        data: {
            breadcrumbs: [
                { name: 'Справочники', url: '/' },
                { name: 'Регионы', url: null },
            ],
            reuse: true,
            searchString: true,
        },
    },
];
